import React, { createContext, PropsWithChildren } from "react";
import { useViewport } from "../utils/viewportHook";

export type MapZoomContextType = Pick<ReturnType<typeof useViewport>, "zoomTo">;

const noop = async () => {};

export const MapZoomContext = createContext<MapZoomContextType>({
  zoomTo: noop,
});

export const MapZoomProvider = ({
  zoomTo,
  children,
}: PropsWithChildren<MapZoomContextType>) => {
  return (
    <MapZoomContext.Provider value={{ zoomTo }}>
      {children}
    </MapZoomContext.Provider>
  );
};
